module.exports = __webpack_public_path__ + "img/logo-home2.f6da9490.png";